// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdCustomDomainsGetResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      domain: string,
      status: string,
      type: string,
    })
  ),
});

export const isCompaniesCompanyIdCustomDomainsPostResult = objectOf({
  id: string,
  domain: string,
  status: string,
  type: string,
});
